/**
 * Finish an in-place sign-in (sc-7039).
 *
 * The redirect-based flows (magic-link, OAuth) land on /auth/callback,
 * which sets the session + claims anonymous scores. Email-OTP verifies
 * IN PLACE (no redirect) — the wall calls this to do the same two steps
 * from an AuthSessionResponse it just received.
 *
 * Kept out of session.ts to avoid tangling that module (pure token store
 * + event bus) with the api/client + identity imports.
 */

import type { AuthSessionResponse } from '@arcraz/arcadia-types';
import { claimAnonymousScores } from '../api/client.js';
import { getOrCreateDeviceId } from '../runtime/identity.js';
import { setSession } from './session.js';

export function establishSession(resp: AuthSessionResponse): void {
  setSession({
    accessToken: resp.accessToken,
    refreshToken: resp.refreshToken,
    expiresAt: Date.now() + resp.expiresIn * 1000,
    email: resp.email,
    userId: resp.userId,
  });
  // sc-3026: claim any anonymous scores on this device onto the new
  // player. Fire-and-forget + idempotent — never block or fail sign-in.
  void claimAnonymousScores({ deviceId: getOrCreateDeviceId() })
    .then((result) => {
      if (result.claimed > 0) {
        console.info('[arcadia84] claimed anonymous scores', { claimed: result.claimed });
      }
    })
    .catch((err) => {
      console.warn('[arcadia84] claim-anonymous-scores failed', { err });
    });
}
